/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import Axios from 'axios'

const ContentLoader = props => {
    //this file's job is to load all of the course data sheets and construct a giant JSON of the whole course. It then feeds that back up to Course.js through props.setContentData

    //turn on to see json output in an overlay. This data is also visible in contentData state at Course.js level
    const debug = false;

    //helper states to handle staged loading


    //potentially add response cache in the future if network performance is ever an issue. there are currently a lot of repeat requests if lessons are shared accross modules

    const loadJSON = async url => {
        //basic ajax get, sends data obj to callback on success
        const dataRes = await Axios.get(url + '?t=' + Date.now());

        if (dataRes.status === 200) {
            return dataRes.data
        }
    }

    const loadSheetJSON = async url => {
        //basic ajax get, sends data obj to callback on success
        let dataRes;
        dataRes = await Axios.get(url + '?sheetId=' + props.sheetId);

        if (dataRes.status === 200) {
            return dataRes.data
        }
    }



    const checkIfDataLoaded = (data) => {
        //check if we are done yet
        //validate each lesson in module has 'chapters' property
        //validate each module in course has 'lessons' property
        return data.modules.filter((module, moduleIndex) => {
            if(!module.lessons) {
                console.log(`Cannot start application because: module ${moduleIndex} does not have any lessons. Module:`, module, `All modules:` , data)
                return true
            };
            //loop through lessons make sure they are all loaded
            return module.lessons.filter((lesson, lessonIndex) => {
                if(!lesson.chapters) {
                    console.log(`Cannot start application because: module ${moduleIndex} lesson ${lessonIndex} does not have any chapters.Offending lesson:`, lesson, `All modules:` , data)
                }
                return !lesson.chapters
            }).length > 0
        }).length === 0;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!props.useSheetsData) {
                // load bundled course data if we're not using google sheets data
                const courseData = await loadJSON('content/course.json');

                // load data for each module, mutate our data object
                courseData.modules = await Promise.all(await courseData.modules.map(async e => {
                    return Object.assign(e, await loadJSON(e.url))
                }));
                // load data for each lesson, mutate our data object
                courseData.modules = await Promise.all(courseData.modules.map(async e => {
                    return Object.assign(e, {lessons: await Promise.all(
                        e.lessons.map(async e2 => Object.assign(e2, await loadJSON(e2.url)))
                    )});
                }));

                if(checkIfDataLoaded(courseData)){
                    //load globals
                    const globalData = await loadJSON('content/globals.json') // , (globalData)=>{
                    courseData.globals = globalData;
                    props.setContentData(courseData);
                }

            } else {
                // load google sheets data static generated data.json files.
                let processedData;
                const getStaticData = async  () => {
                    try {
                        const staticJSON = await Axios.get('json/data.json');
                        processedData =  staticJSON.data
                    } catch (e) {
                        alert('Error fetching JSON data file')
                        console.log(e)
                    }
                }
                 await getStaticData().then(() => {
                     props.setContentData(processedData)

                 })
                 if (!processedData) {
                     throw new Error("could nor process data, halting")
                     return
                 }


            }
        }
        fetchData();
    }, [])

    if(debug){
        return (
            <div className={`ContentLoader debug`}
                style={{
                    position:"absolute",
                    top:0,
                    left:0,
                    width:'100%',
                    background:'black',
                    color:'white',
                    opacity:0.8
                }}>
                <pre>
                    {JSON.stringify(props.contentData, null, 2)}
                </pre>
            </div>
        )
    }
    return <></>
}

export default ContentLoader
